import { IIsiUIFlowResult } from "./IIsiUIFlowResult";
import { IIsiUIFlowResultGeneric } from "./IIsiUIFlowResultGeneric";

/**
 * Classe static factorisant les méthodes régulièrement utilisées en lien avec les IsiUiFlowUtils
 */
export abstract class IsiUiFlowUtils
{
    // =============================
    // Public const
    // =============================

    /**
     * Shortcut à retourner par les méthodes avec un type de retour "Promise<IIsiUIFlowResult>" pour continuer l'execution quand tout s'est bien déroulé
     */
    public static readonly continueExecution: IIsiUIFlowResult = { continue: true, result: true };

    /**
     * Shortcut à retourner par les méthodes avec un type de retour "Promise<IIsiUIFlowResult>" pour stopper l'exécution quand une erreur est apparue
     */
    public static readonly stopExecution: IIsiUIFlowResult = { continue: false, result: false };



    // =============================
    // Public functions
    // =============================

    /**
     * Shortcut pour créer un IIsiUIFlowResultGeneric depuis un IIsiUIFlowResult existant
     * 
     * @param flow Valeurs à copier dans le flow retourné
     * @param response Valeur à mettre dans la "reponse" du flow retourné
     * 
     * @returns Le IIsiUIFlowResultGeneric
     */
    public static createFlowWithResponse<TResult>(flow: IIsiUIFlowResult, response: TResult): IIsiUIFlowResultGeneric<TResult> {

        return { continue: flow?.continue, result: flow?.result, reponse: response }
    }

    /**
     * Shortcut pour tracer puis stopper l'execution si l'on tombe dans le "default" d'un "switch case" pour une méthode qui retourne un IIsiUIFlowResult.
     * 
     * (Pour utiliser cette méthode, penser à faire un `LoadMsgToJs("Err", "UnexpectedCase")` dans l'aspx.vb)
     * 
     * @param notExpectedCase Le cas non pris en charge, qui sera logué dans les traces
     * 
     * @returns Un IIsiUIFlowResult qui demande de stopper l'exécution
     */
    public static stopExecutionForNonExpectedCase(notExpectedCase: string): IIsiUIFlowResult {

        const errorMsg: string = getMessagesForJavascript()?.GetMessage("UnexpectedCase")?.L_MESSAGE?.replace("$s", notExpectedCase);
        uiCore.logError(errorMsg);

        return this.stopExecution;
    }
}